import { render, staticRenderFns } from "./Alergia.vue?vue&type=template&id=61feb939&scoped=true"
import script from "./Alergia.vue?vue&type=script&lang=js"
export * from "./Alergia.vue?vue&type=script&lang=js"
import style0 from "./Alergia.vue?vue&type=style&index=0&id=61feb939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61feb939",
  null
  
)

export default component.exports